import { connect } from 'react-redux';
import PriceCheckerContainer from './PriceCheckerContainer';
import {
  getLastUpdated,
  getIsActualizationProcess,
  getActualizationFetching,
} from '../../store/selectors/actualization';
import { ACTUALIZATION_TIMEOUT } from '../../store/constants/actualization';

const mapStateToProps = (state) => ({
  lastUpdated: getLastUpdated(state),
  isVisible: getIsActualizationProcess(state),
  fetching: getActualizationFetching(state),
  className: 'checkout-price-checker-timer',
  timeout: ACTUALIZATION_TIMEOUT,
});

export default connect(mapStateToProps)(PriceCheckerContainer);
